/**
 * @module IDEE/style/baseline
 */

/**
 * Estilo superior "baseline".
 * @const
 * @type {string}
 * @public
 * @api
 */
export const TOP = 'top';

/**
 * Estilo medio "baseline".
 * Solo disponible para OpenLayers.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const MIDDLE = 'middle';

/**
 * Estilo inferior "baseline".
 * @const
 * @type {string}
 * @public
 * @api
 */
export const BOTTOM = 'bottom';

/**
 * Estilo alfabético "baseline".
 * Solo disponible para OpenLayers.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const ALPHABETIC = 'alphabetic';

/**
 * Estilo colgante "baseline".
 * Solo disponible para OpenLayers.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const HANGING = 'hanging';

/**
 * Estilo ideográfico "baseline".
 * Solo disponible para OpenLayers.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const IDEOGRAPHIC = 'ideographic';

/**
 * Estilo "baseline".
 * Solo disponible para Cesium.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const BASELINE = 'baseline';

/**
 * Estilo medio "baseline".
 * Solo disponible para Cesium.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CENTER = 'center';
